import { signOut, User } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../Lib/Firebase";
import AdminSecurityTab from "./AdminSecurityTab";

export default function AdminMfaSetup({ user }: { user: User }) {
    const navigate = useNavigate();

    const finish = async () => {
        await signOut(auth);
        navigate("/admin-login", { replace: true });
    };

    return <main className="min-h-screen bg-slate-50 px-4 py-8 sm:px-8">
        <div className="mx-auto max-w-3xl">
            <header className="mb-6 flex items-center justify-between gap-4">
                <a href="/" className="flex items-center gap-3">
                    <span className="grid h-11 w-11 place-items-center rounded-xl bg-white shadow ring-1 ring-blue-100">
                        <img src="/images/jpg/mockzo-logo-v3.webp" alt="MockZo logo" className="h-8 w-8" />
                    </span>
                    <div><p className="font-black text-[#0b2f75]">MockZo Admin</p><p className="text-xs text-slate-500">Security setup</p></div>
                </a>
                <button onClick={finish} className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100">Sign out</button>
            </header>
            <div className="mb-5 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm leading-6 text-amber-950">
                Your administrator email is approved, but the dashboard remains locked until authenticator MFA is enrolled and verified in a fresh sign-in.
            </div>
            <AdminSecurityTab user={user} onEnrolled={finish} />
        </div>
    </main>;
}
